import{SvelteComponent as e,safe_not_equal as o,init as l}from"svelte/internal";import"svelte/internal/disclose-version";class u extends e{constructor(t){super(),l(this,t,null,null,o,{})}}export{u as default};
